var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    {
      attrs: { show: _vm.show },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Subir Detalle" },
        on: { cerrar: _vm.closeModal }
      }),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.pasos.informacionGeneral.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.pasos.informacionGeneral, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    flat: "",
                    value: _vm.pasos.informacionGeneral.step
                  },
                  on: { click: _vm.handleInfoGeneral }
                },
                [
                  _c("span", [_vm._v("Detalle")]),
                  _c("v-icon", [_vm._v("info")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showInfo,
              expression: "showInfo"
            }
          ],
          staticClass: "cardnew",
          attrs: { align: "center" }
        },
        [
          _c("br"),
          _c(
            "div",
            { staticClass: "orden_compra", attrs: { align: "center" } },
            [
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" }
                        },
                        [
                          _c("v-container", { attrs: { "grid-list-md": "" } }, [
                            _vm.id_orden_compra != null
                              ? _c("h1", [
                                  _vm._v(
                                    "\n                Cargar Detalle de Orden: " +
                                      _vm._s(_vm.id_orden_compra) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ],
                        1
                      ),
                      _vm.tipoProveedorSelected
                        ? _c(
                            "v-container",
                            [
                              _c("v-divider"),
                              _c("FormularioCostos", {
                                ref: "formCostos",
                                attrs: {
                                  precioCarga: _vm.precioCarga,
                                  compranumero: _vm.id_orden_compra,
                                  cantidadCargados: _vm.cantidadCargados,
                                  precioCargaOtros: _vm.precioCargaOtros
                                },
                                on: {
                                  nuevoUnitario: function($event) {
                                    return _vm.calcularUnitario($event)
                                  }
                                }
                              }),
                              _c("v-divider", { staticClass: "mt-2" })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-container",
                        [
                          !_vm.tipoProveedorSelected
                            ? _c("v-divider", { staticClass: "mb-4" })
                            : _vm._e(),
                          _c(
                            "FormFieldsContainer",
                            [
                              _c("v-flex", { attrs: { sm6: "", md6: "" } }, [
                                _c("div", { staticClass: "layout row wrap" }, [
                                  _c(
                                    "div",
                                    { staticClass: "flex xs8 sm8 md8" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          xs3: "",
                                          sm3: "",
                                          md3: "",
                                          label:
                                            "Seleccione Archivo para carga masiva de series",
                                          heigh: "",
                                          "error-messages": _vm.errors.collect(
                                            "archivo"
                                          ),
                                          "data-vv-name": "archivo",
                                          readonly: "readonly"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.$refs.image.click()
                                          }
                                        },
                                        model: {
                                          value: _vm.fileName,
                                          callback: function($$v) {
                                            _vm.fileName = $$v
                                          },
                                          expression: "fileName"
                                        }
                                      }),
                                      _c("input", {
                                        ref: "image",
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          type: "file",
                                          accept: ".xlsx, .xls",
                                          clearable: "",
                                          id: "archivoExcel"
                                        },
                                        on: { change: _vm.prepare_file_upload }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "flex xs2 sm2 md2" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.fileName,
                                              expression: "fileName"
                                            }
                                          ],
                                          staticStyle: { "margin-top": "10px" },
                                          on: { click: _vm.quitarRegistro }
                                        },
                                        [_vm._v("✖")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "flex xs2 sm2 md2" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "btn-sucursal btn-cargar v-btn theme--light",
                                          staticStyle: { "margin-top": "10px" },
                                          attrs: { disabled: _vm.errorArchivo },
                                          on: {
                                            click: function($event) {
                                              return _vm.verifyCosts()
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", [_vm._v("attach_file")]),
                                          _vm._v("Cargar\n                    ")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]),
                              _c("br"),
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    xs12: "",
                                    sm12: "",
                                    md12: "",
                                    layout: ""
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "divP",
                                      attrs: { align: "left" }
                                    },
                                    [
                                      _c("p", { staticClass: "aclaracion" }, [
                                        _vm._v(
                                          "\n                    Se recomienda utilizar el formato de la siguiente\n                    plantilla para evitar conflictos al momento de cargar la\n                    solicitud.\n                    "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n                    Por favor, ingresar los datos según los formatos que se\n                    muestran en la fila de ejemplo de la plantilla.\n                  "
                                        )
                                      ]),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btnPlantilla",
                                          attrs: {
                                            flat: "",
                                            small: "",
                                            color: "primary"
                                          },
                                          on: { click: _vm.descargarPlantilla }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "importExportBtnIcon"
                                            },
                                            [_vm._v("cloud_download")]
                                          ),
                                          _vm._v("  \n                    "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "importExportBtnTexto"
                                            },
                                            [_vm._v("Descargar Plantilla")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c("v-divider", { staticClass: "mt-4" })
                        ],
                        1
                      ),
                      _c(
                        "v-container",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showSeries,
                              expression: "showSeries"
                            }
                          ],
                          staticClass: "modalCargarArchivo"
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c("MantenedorGrid", {
                                staticClass: "ag-theme-material",
                                staticStyle: {
                                  width: "100%",
                                  "font-family": "'Asap' sans-serif"
                                },
                                attrs: { gridOptions: _vm.gridOptions }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "380" },
          model: {
            value: _vm.mostrarModalConfirmar,
            callback: function($$v) {
              _vm.mostrarModalConfirmar = $$v
            },
            expression: "mostrarModalConfirmar"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticStyle: {
                        "font-size": "17px",
                        "margin-left": "10px !important"
                      }
                    },
                    [_vm._v("\n          Confirmación\n        ")]
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "div",
                { attrs: { id: "alinear" } },
                [
                  _c("v-card-text", [
                    _vm._v(
                      "\n          " +
                        _vm._s("¿Está seguro que desea continuar?") +
                        "\n          "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n          Las series serán cargadas en CRM y en INET con sus respectivos\n          costos.\n          "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.tipoProveedorSelected
                            ? "Los costos de importación serán prorrateados entre la cantidad de series cargadas, independiente de su resultado final."
                            : ""
                        ) +
                        "\n        "
                    )
                  ])
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        "data-testid": "v-btn--cancelar",
                        color: "white",
                        depressed: "",
                        small: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.confirmCallback(false)
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "#526da5" } }, [
                        _vm._v("Cancelar")
                      ])
                    ]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        "data-testid": "v-btn--aceptar",
                        color: "#526da5",
                        depressed: "",
                        small: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.confirmCallback(true)
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "white" } }, [
                        _vm._v("Confirmar")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "400" },
          model: {
            value: _vm.mostrarModalErrores,
            callback: function($$v) {
              _vm.mostrarModalErrores = $$v
            },
            expression: "mostrarModalErrores"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mt-n2",
                      on: {
                        click: function($event) {
                          _vm.mostrarModalErrores = false
                        }
                      }
                    },
                    [_vm._v("close")]
                  ),
                  _c(
                    "v-toolbar-title",
                    {
                      staticStyle: {
                        "font-size": "17px",
                        "margin-left": "10px !important"
                      }
                    },
                    [_vm._v("\n          Error\n        ")]
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "div",
                { attrs: { id: "alinear" } },
                [
                  _c("v-card-text", [
                    _vm._v(
                      "\n          El documento cuenta con los siguientes errores:"
                    ),
                    _c("br"),
                    _c(
                      "ul",
                      _vm._l(_vm.arrayError, function(error, index) {
                        return _c("li", { key: index }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(error) +
                              "\n            "
                          )
                        ])
                      }),
                      0
                    ),
                    _c("br"),
                    _vm._v(
                      "\n          Para evitar estos errores le recomendamos usar la plantilla:"
                    ),
                    _c("br"),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-center" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { flat: "", small: "", color: "primary" },
                            on: { click: _vm.descargarPlantilla }
                          },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "importExportBtnIcon" },
                              [_vm._v("cloud_download")]
                            ),
                            _c(
                              "span",
                              { staticClass: "importExportBtnTexto" },
                              [_vm._v("Descargar Plantilla")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        "data-testid": "v-btn--aceptar",
                        color: "#526da5",
                        depressed: "",
                        small: ""
                      },
                      on: {
                        click: function($event) {
                          _vm.mostrarModalErrores = false
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "white" } }, [
                        _vm._v("Aceptar")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.showReporteGenerado
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c(
                    "div",
                    [
                      _c("div", { staticClass: "titleEvidencia" }, [
                        _c("h2", { staticClass: "importExportBtnIcon" }, [
                          _vm._v("Reporte Solicitado")
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "buttonClose buttonCloseEvidencia",
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.closeReporte()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("close")]
                              ),
                              _vm._v("  \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c("p", { staticStyle: { "margin-top": "40px" } }, [
                            _vm._v(_vm._s(_vm.texto_reporte))
                          ])
                        ]),
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c(
                            "p",
                            { staticStyle: { "margin-top": "40px" } },
                            [
                              _vm._v(
                                "\n                Puede ver sus reportes en el menú\n                "
                              ),
                              _c(
                                "router-link",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "font-size": "13px"
                                  },
                                  attrs: {
                                    "active-class": "router-link-active",
                                    to: "/conecta-reportes"
                                  }
                                },
                                [_vm._v("Informes")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }